import {Image} from "@/types";

export type WhyUsType = {
    id: number;
    title: string;
    description: string;
    image: Image;
}
export const whyUs: WhyUsType[] = [
    {
        id: 1,
        title: 'Licensed Experts',
        description: 'Qualified, insured electricians',
        image: {
            id: 1,
            url: '/images/why-us/why1.svg',
            original: '/images/why-us/why1.svg',
            title: 'licensed electricians',
        }
    },
    {
        id: 2,
        title: 'Reliable Service',
        description: 'On-time and dependable',
        image: {
            id: 2,
            url: '/images/why-us/why2.svg',
            original: '/images/why-us/why2.svg',
            title: 'reliable electrical service',
        }
    },
    {
        id: 3,
        title: 'Solar Specialists',
        description: 'Panels, batteries, renewables',
        image: {
            id: 3,
            url: '/images/why-us/why3.svg',
            original: '/images/why-us/why3.svg',
            title: 'solar energy',
        }
    },
    {
        id: 4,
        title: 'Energy Savings',
        description: 'Cut costs, save power',
        image: {
            id: 4,
            url: '/images/why-us/why4.svg',
            original: '/images/why-us/why4.svg',
            title: 'energy efficient upgrades',
        }
    },
    {
        id: 5,
        title: 'Eco Friendly',
        description: 'Energy-saving options',
        image: {
            id: 5,
            url: '/images/why-us/why5.svg',
            original: '/images/why-us/why5.svg',
            title: 'solar and green energy',
        }
    },
    {
        id: 6,
        title: 'Proven Results',
        description: 'Reliable every time',
        image: {
            id: 6,
            url: '/images/why-us/why6.svg',
            original: '/images/why-us/why6.svg',
            title: 'trusted electricians',
        }
    }
];

